import logError from "lib/utils/errors/logError";

/**
 * boosted from https://github.com/PlatziDev/redux-catch
 * because they don't distribute a UMD build
 */

const errorMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (e) {
    if (__DEV__) {
      throw e;
    }
    const errorId = logError(e);
    setTimeout(() => {
      store.dispatch({
        type: "app/CREATE_ALERT",
        alert: {
          type: "error",
          uuid: "APP_ERROR",
          content: `Wystąpił błąd aplikacji` + (errorId ? ` nr ${errorId}` : ""),
        },
      });
    });
    return store.getState();
  }
};

export default errorMiddleware;



// WEBPACK FOOTER //
// ./src/app/store/errorMiddleware.js